import { Injectable, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormSubmissionService } from './form-submission.service';
import { FormDataService } from './form-data.service';
import { JornayaService } from './jornaya.service';
import { Session } from 'inspector';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root'
})
export class LandingHelperService implements OnInit {

  environment: any = {
    apiBaseUrl: "https://landinghelperevolute.azurewebsites.net/api/",
    apiToken: "79148e5b-5a49-49b2-8eb1-1eebcec31730"
  };  

  constructor(
    private http: HttpClient,
    private formSubmissionService: FormSubmissionService,
    private formDataService: FormDataService,
    private window: WindowService,
    @Inject(PLATFORM_ID) private platformId: Object    
  ) { }

  ngOnInit(): void {
    // this.getActiveURLByOffer(354);
  }  

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'withCredentials': 'true',
      'Authorization': 'true',
      'Token': this.environment.apiToken
    });
  }
  
  private getSaveLandingApiProgressUrl(): string {
    return `${this.environment.apiBaseUrl}/SaveLandingApiProgress`;
  }

  private getActiveURLByOfferUrl(): string {
    return `${this.environment.apiBaseUrl}/GetActiveURLByOffer`;
  }

  async getActiveURLByOffer(OfferID: number): Promise<any>  {
    try {      

      const headers = this.getRequestHeaders();
      const saveLeadURL = this.getActiveURLByOfferUrl() + "?OfferID=" +  OfferID.toString() + "&code=e6c2CCdw4kZSwZcw2bMhAb9tr9CdYh5LWKEucjImXnkfAzFuTbmqog==";

      const response = await this.http.get(saveLeadURL, { headers }).toPromise();
      return response;

    } catch (error) {
      console.error('Submission error:', error);
      throw error;
    }

  }



}
